export const MAX_CHAT_TITLE_LENGTH = 255
export const MAX_CHAT_MESSAGE_LENGTH = 20_000
